<template>
    <ul @scroll="updateGradients" ref="navBar">
      <li
        v-for="page in pages"
        :key="page.label"
        @click="goToPage(page)"
        :class="$route.path === page.path && 'current-route'"
      >
        {{page.label}}
      </li>
      <li id="left-gradient" :class="showLeftGradient && 'visible'"></li>
      <li id="right-gradient" :class="showRightGradient && 'visible'"></li>
    </ul>
</template>

<script>
export default {
  name: 'NavBar',
  data () {
    return {
      pages: [
        {
          label: 'Hacker News',
          path: '/about'
        },
        {
          label: 'Top',
          path: '/top'
        },
        {
          label: 'New',
          path: '/new'
        },
        {
          label: 'Ask',
          path: '/ask'
        },
        {
          label: 'Show',
          path: '/show'
        },
        {
          label: 'Job',
          path: '/job'
        }
      ],
      showLeftGradient: false,
      showRightGradient: false
    }
  },
  methods: {
    goToPage (page) {
      if (this.$route.path !== page.path) {
        this.$router.push(page.path)
      }
    },
    updateGradients () {
      const bar = this.$refs.navBar
      this.showLeftGradient = bar.scrollLeft !== 0
      this.showRightGradient = bar.scrollLeft + window.innerWidth < bar.scrollWidth
    }
  },
  mounted () {
    window.addEventListener('resize', this.updateGradients)
    this.$nextTick(this.updateGradients)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateGradients)
  }
}
</script>

<style lang="scss" scoped>
  @import "../styles/theme";

  ul {
    width: 100%;
    height: $navBarHeight;
    display: flex;
    color: $fg-text;
    white-space: nowrap;
    background-color: $default-background;
    position: absolute;
    top: 0;
    left: 0;
    list-style: none;
    padding: 0;
    margin: 0;
    overflow: auto hidden;

    li {
      $padding: 10px;
      padding: $padding 15px;
      line-height: $navBarHeight - (2 * $padding);
      transition: background-color 0.2s;
      user-select: none;

      &:hover {
        cursor: pointer;
        background-color: $highlight-background;
      }

      &.current-route {
        background-color: $selected-background;
      }

      &:active {
        background-color: $click-background;
      }
    }
  }
  #left-gradient, #right-gradient {
    position: fixed;
    width: 50px;
    height: $navBarHeight;
    top: 0;
    opacity: 0;
    transition: opacity linear 0.5s;
    padding: 0;
    pointer-events: none;

    &.visible {
      opacity: 1;
    }
  }

  #left-gradient {
    left: 0;
    background-image: linear-gradient(to right, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0));
  }

  #right-gradient {
    right: 0;
    background-image: linear-gradient(to left, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0));
  }
</style>
